import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { PARKING_DENSITY_GRADIENT_LEGEND } from '../../../constants/legends';

const ParkingDensityComponent = () => (
    <LegendRenderer config={PARKING_DENSITY_GRADIENT_LEGEND} />
);

export const ParkingDensityLegend = withDisplayedLayersCheck(ParkingDensityComponent, t`Плотность парковок`);
